import { registerComponent } from '../app'

const WatchImageLoad = (scope, el) => {
	const props = {
		loadedClass: 'loaded'
	}

	el.addEventListener('imageLoad', () => el.classList.add(props.loadedClass))
}

registerComponent('watch-image-load', WatchImageLoad)
